import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class SicilBilgileriListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "SicilBilgileriListe";
    super(baseUrl);
  }


  getSicilBilgileriListe(sicilKodu?: number, tcKimlikNo?: string, vergiNo?: string, cepTelefonNo?: string){
    var request= new SicilBilgileriListeRequest(sicilKodu, tcKimlikNo, vergiNo, cepTelefonNo);
    return this.post("",request, true);
  }

}
export default new SicilBilgileriListeAPI();
class SicilBilgileriListeRequest {
  public SicilKodu?: number;
    public TcKimlikNo?: string;
    public VergiNo?: string;
    public cepTelefonNo?: string;
  constructor( sicilKodu?: number, tcKimlikNo?: string, vergiNo?: string, cepTelefonNo?: string) {
   
    this.SicilKodu = sicilKodu;
    this.TcKimlikNo = tcKimlikNo;
    this.VergiNo = vergiNo;
    this.cepTelefonNo = cepTelefonNo;

  }
}
export { SicilBilgileriListeRequest };